import React from "react";
import {Link, useLocation } from "react-router-dom";
import {useTranslation} from "react-i18next";


interface ChipProps {
    label: string,
    width: string,
    showChevron?: boolean,
    href?: string,
    onClick?: (e: any) => void
}

const Chip: React.FC<ChipProps> = ({label, width, showChevron = true, href, onClick}) => {
    const location = useLocation();
    const isActive = href && location.pathname === href;

    const content = (
        <div className={`${width} relative flex items-center rounded-full py-1.5 pl-3 transition-colors duration-200 ${
            isActive ? "bg-white shadow text-[#333333]" : "bg-[#333333] text-white"
        }`}>
    <span className="font-medium text-[15px] leading-[24px]">
      {label}
    </span>
            {showChevron && (
                <div className="relative flex items-center justify-center w-4 h-4 ml-2 mr-2">
                    <img
                        src={isActive ? "/images/chevronActivePage.svg" : "/images/ChevronDown.svg"}
                        alt="Chevron"
                    />
                </div>
            )}
        </div>
    );

    if (href) {
        return (
            <Link to={href} className="flex" onClick={onClick}>
                {content}
            </Link>
        );
    }

    return content;
};

const MainChipsContainer: React.FC = () => {
    const {t} = useTranslation();


    return (
        <div className="flex flex-row justify-center items-center gap-3 mx-auto h-[36px] ">
            <Chip label={t("main.headerChips.1")} width="w-auto" href="/main/services" />
            <Chip label={t("main.headerChips.2")} width="w-auto" href="/main/products" />
            <Chip label={t("main.headerChips.3")} width="w-auto" href="/main/projects" />
            <Chip label={t("main.headerChips.4")} width="w-auto" href="/main/about" />
            <Chip label={t("main.headerChips.5")} width="w-auto" href="/main/bitrix24" />
            <Chip label={t("main.headerChips.6")} width="w-auto" href="/main/FAQ" />
        </div>
    );
};

export default MainChipsContainer;
